jQuery(document).on("wpmLoadAlways", async () => {

	try {
		// Return if on purchase confirmation page
		if (wpmDataLayer?.shop?.page_type === "order_received_page") return

		// console.log("ACR running")

		// Return if ACR cookie has not been set
		if (!wpm.getCookie("pmw_automatic_conversion_recovery")) return

		// console.log("ACR cookie found")

		// Return if window.sessionStorage is not supported
		if (!window.sessionStorage) return

		// console.log("window.sessionStorage available")

		// Return if the check has already run in the current session
		if (window.sessionStorage.getItem("_pmw_acr_attempted")) return

		// console.log("ACR check not run in this session")

		// Get the order details from the server
		await wpm.getAcrOrderDetails()

		// console.log("ACR order details retrieved")

		// console.log("wpmDataLayer.order", wpmDataLayer.order)

		// Fire the conversion pixels
		jQuery(document).trigger("wpmOrderReceivedPage")

		// Save the order ID on the server to prevent duplicate conversions
		wpm.writeOrderIdToStorage(wpmDataLayer.order.id, "acr_full_auto")

		// Delete the ACR cookie
		wpm.deleteCookie("pmw_automatic_conversion_recovery")

	} catch (error) {
		if (window.sessionStorage) window.sessionStorage.setItem("_pmw_acr_attempted", JSON.stringify(true))
		console.error(error)
	}
})
